import React, { useEffect } from 'react';
import { useMsal, useAccount } from '@azure/msal-react';
import { loginRequest } from '../../auth/msal';
import { useLocation, Navigate } from 'react-router-dom';
import { isAuthenticated, isTokenExpired } from './tokenUtils';
import { toast } from 'react-toastify';
import { hasModuleAccess, ROUTE_MODULE_MAP } from './roleBasedAccess';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const appAuthenticated = isAuthenticated();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts && accounts.length > 0 ? accounts[0] : null);

  useEffect(() => {
    // Check for token expiration on route change for authenticated users
    if (appAuthenticated) {
      // Double-check token expiration when navigating between protected routes
      if (isTokenExpired()) {
        // Clear all authentication data
        localStorage.removeItem('LoginInfo');
        localStorage.removeItem('UserName');
        localStorage.removeItem('UserId');
        localStorage.removeItem('RoleId');
        localStorage.removeItem('Token');
        localStorage.removeItem('Company');

        // Show a message about session expiration
        toast.error('Your session has expired. Please log in again.', {
          position: 'top-right',
          autoClose: 5000,
        });
      }
    }
  }, [appAuthenticated, location.pathname]);

  // Allow access if either the app has a local token OR MSAL account exists
  console.log('ProtectedRoute: Access Check', {
    appAuthenticated,
    hasMsalAccount: !!account,
    totalAccounts: accounts ? accounts.length : 0,
    loginInfo: localStorage.getItem('LoginInfo') ? 'Present' : 'Missing',
    token: localStorage.getItem('Token') ? 'Present' : 'Missing'
  });

  if (!appAuthenticated && !account) {
    console.warn('ProtectedRoute: Denying access, redirecting to login');
    instance.loginRedirect({ ...loginRequest })
    return null;
  }

  // Check for module access
  const currentPath = location.pathname;
  // Simple exact match for now. 
  // TODO: Implement regex or prefix matching if routes have parameters.
  const requiredModule = ROUTE_MODULE_MAP[currentPath];

  if (requiredModule) {
    let userRoles = [];
    try {
      const raw = sessionStorage.getItem('MSAL_LAST_IDTOKEN_CLAIMS');
      if (raw) {
        const claims = JSON.parse(raw);
        userRoles = Array.isArray(claims?.roles) ? claims.roles : [];
      }
    } catch (_err) {
      console.error('Error parsing MSAL claims:', _err);
    }

    if (!hasModuleAccess(requiredModule, userRoles)) {
      // User does not have access to this module
      // You might want to redirect to a "Not Authorized" page or the dashboard
      // For now, let's redirect to the root which handles redirection based on role
      // or show a toast and redirect
      toast.error(`You do not have access to ${requiredModule}.`, {
        position: 'top-right',
        autoClose: 3000,
      });
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;